import styled from 'styled-components';

export const TreeNodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
